import React from 'react';
import { Block } from '@mui/icons-material';
import weirdclothing1 from '../img/weirdclothing/weirdclothing1.png'
import weirdclothing2 from '../img/weirdclothing/weirdclothing2.png'

const WeirdClothing = ({ onImageClick }) => {
  return (
    <>
      <div className="help-center__examples help-center__examples--first">
        <div className="help-center__examples-header">
          <Block />
          <h3 className="help-center__examples-title">Weird clothing and fashion issues to avoid</h3>
        </div>
        
        <div className="help-center__example-card">
          <div className="help-center__example-images help-center__example-images--grid-2">
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
              <img src={weirdclothing1} alt="" onClick={() => onImageClick && onImageClick(weirdclothing1)} style={{cursor: 'pointer'}} />
              </div>
              <div className="help-center__image-caption">
                Double panties
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
              <img src={weirdclothing2} alt="" onClick={() => onImageClick && onImageClick(weirdclothing2)} style={{cursor: 'pointer'}} />
              </div>
              <div className="help-center__image-caption">
                Her pant is weird
              </div>
            </div>
            
          </div>
          
         
        </div>
      </div>
    </>
  );
};

export default WeirdClothing;